export default __webpack_public_path__ + "static/media/new-icon-my-profile.8f15009d.svg";